import { render, staticRenderFns } from "./ContratApportCard.vue?vue&type=template&id=64bdf282"
import script from "./ContratApportCard.vue?vue&type=script&lang=js"
export * from "./ContratApportCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports